import {
  FETCH_ALL_LICENSES,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSES](state, licenses) {
    state.all = licenses;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/license/mutations.js